<template>
  <div class="product-add">
    <el-tabs v-model="activeName">
      <el-tab-pane label="课程分类" name="courseclass"></el-tab-pane>
      <el-tab-pane label="课程管理" name="course"></el-tab-pane>
    </el-tabs>
    <!--课程分类-->
    <courseclass v-show="activeName == 'courseclass'"></courseclass>
    <!--课程管理-->
    <course v-show="activeName == 'course'"></course>
  </div>
</template>
<script>
import courseclass from "./courseclass";
import course from "./course";

export default {
  components: {
    courseclass,
    course
  },
  data() {
    return {
      activeName: "courseclass"
    };
  },
  methods: {}
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/train/center/index.vue